import { lazy } from 'react';

export const WarehousePage = lazy(() => import('./WarehousePage'));
export const AdminWarehousePage = lazy(() => import('./AdminWarehousePage'));
export const WarehouseSettingsPage = lazy(() => import('./WarehouseSettingsPage'));
